import React from "react";

const Skills = () => {
  return (
    <section id="skills" className="p-12 bg-[#cba36f]">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-10">SKILLS</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white shadow-lg p-6 flex flex-col items-center space-y-4 rounded-lg transition duration-300 ease-in-out hover:scale-105 hover:shadow-xl">
            <h3 className="text-2xl font-semibold p-3 border-b-4 border-gray-400 mb-4">
              Languages
            </h3>

            <img
              src="https://img.shields.io/badge/Java-007396?style=for-the-badge&logo=Java&logoColor=white"
              alt="Java Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Python-3776AB?style=for-the-badge&logo=Python&logoColor=white"
              alt="Python Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=JavaScript&logoColor=white"
              alt="JavaScript Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/HTML5-E34F26?style=for-the-badge&logo=HTML5&logoColor=white"
              alt="HTML5 Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/CSS3-1572B6?style=for-the-badge&logo=CSS3&logoColor=white"
              alt="CSS3 Badge"
              className="h-10"
            />
          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-4 transition duration-300 ease-in-out hover:scale-105 hover:shadow-xl">
            <h3 className="text-2xl font-semibold p-3 border-b-4 border-gray-400 mb-4">
              Frameworks
            </h3>
            <img
              src="https://img.shields.io/badge/Spring-6DB33F?style=for-the-badge&logo=Spring&logoColor=white"
              alt="Spring Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Spring Boot-6DB33F?style=for-the-badge&logo=Spring Boot&logoColor=white"
              alt="Spring Boot Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Spring Security-6DB33F?style=for-the-badge&logo=Spring Security&logoColor=white"
              alt="Spring Security Badge"
              className="h-10"
            />

            <img
              src="https://img.shields.io/badge/React-61DAFB?style=for-the-badge&logo=React&logoColor=white"
              alt="React Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Vue.js-4FC08D?style=for-the-badge&logo=Vuedotjs&logoColor=white"
              alt="Vue.js Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Django-092E20?style=for-the-badge&logo=Django&logoColor=white"
              alt="Django Badge"
              className="h-10"
            />
          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-4 transition duration-300 ease-in-out hover:scale-105 hover:shadow-xl">
            <h3 className="text-2xl font-semibold p-3 border-b-4 border-gray-400 mb-4">
              DataBase
            </h3>
            <img
              src="https://img.shields.io/badge/Postgresql-4169E1?style=for-the-badge&logo=Postgresql&logoColor=white"
              alt="PostgreSQL Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/MySQL-4479A1?style=for-the-badge&logo=MySQL&logoColor=white"
              alt="MySQL Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/MariaDB-003545?style=for-the-badge&logo=MariaDB&logoColor=white"
              alt="MariaDB Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Redis-DC382D?style=for-the-badge&logo=Redis&logoColor=white"
              alt="Redis Badge"
              className="h-10"
            />
          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-4 transition duration-300 ease-in-out hover:scale-105 hover:shadow-xl">
            <h3 className="text-2xl font-semibold p-3 border-b-4 border-gray-400 mb-4">
              Infra
            </h3>
            <img
              src="https://img.shields.io/badge/Amazon EC2-FF9900?style=for-the-badge&logo=Amazonec2&logoColor=white"
              alt="Amazon EC2 Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Docker-2496ED?style=for-the-badge&logo=Docker&logoColor=white"
              alt="Docker Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Jenkins-D24939?style=for-the-badge&logo=Jenkins&logoColor=white"
              alt="Jenkins Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Nginx-009639?style=for-the-badge&logo=Nginx&logoColor=white"
              alt="Nginx Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/RabbitMQ-FF6600?style=for-the-badge&logo=RabbitMQ&logoColor=white"
              alt="RabbitMQ Badge"
              className="h-10"
            />
          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-4 transition duration-300 ease-in-out hover:scale-105 hover:shadow-xl">
            <h3 className="text-2xl font-semibold p-3 border-b-4 border-gray-400 mb-4">
              Collaboration Tools
            </h3>
            <img
              src="https://img.shields.io/badge/Github-181717?style=for-the-badge&logo=Github&logoColor=white"
              alt="GitHub Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Jira-0052CC?style=for-the-badge&logo=Jirasoftware&logoColor=white"
              alt="Jira Badge"
              className="h-10"
            />
            <img
              src="https://img.shields.io/badge/Figma-F24E1E?style=for-the-badge&logo=Figma&logoColor=white"
              alt="Figma Badge"
              className="h-10"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
